import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardTemplate from "../DashboardLayout";
import ThemesCard from "../../../components/ui/ThemesCard";

const SetTheme = () => {
  const [isOnSetThemePage, setIsOnSetThemePage] = useState(false);
  const navigate = useNavigate();

  const themes = [
    { id: 1, ribbonType: "basic" },
    { id: 2, ribbonType: "premium" },
    { id: 3, ribbonType: "vip" },
  ];

  useEffect(() => {
    setIsOnSetThemePage(true);
  }, []);

  const handleThemeClick = (id) => {
    navigate(`/personal-information?themeId=${id}`);
  };

  return (
    <DashboardTemplate>
      <div className="max-w-6xl mx-auto px-4 md:px-0">
        <h1 className="text-2xl font-bold font-montserrat">
          Pilih Tema yang sesuai dengan gaya pernikahanmu
        </h1>

        {/* Tema yang Dimiliki */}
        <h2 className="text-xl font-semibold font-montserrat mt-6">
          Tema yang Dimiliki
        </h2>
        <div className="flex flex-wrap gap-6 justify-start mt-2">
          {themes.map((theme) => (
            <ThemesCard
              key={theme.id}
              ribbonType={theme.ribbonType}
              isOnSetThemePage={isOnSetThemePage}
              isPremium={false}
              onClick={() => handleThemeClick(theme.id)}
            />
          ))}
        </div>

        {/* Tema Premium */}
        <h2 className="text-xl font-semibold font-montserrat mt-10 text-start">
          Tema Premium
        </h2>
        <div className="grid grid-cols-3 gap-6 place-items-center mt-2">
          {themes
            .filter((theme) => theme.ribbonType === "premium")
            .map((theme) => (
              <ThemesCard
                key={theme.id}
                ribbonType={theme.ribbonType}
                isOnSetThemePage={isOnSetThemePage}
                isPremium={true}
                onClick={() => handleThemeClick(theme.id)}
              />
            ))}

          {/* Tambahkan div kosong jika item kurang dari 3 agar tetap sejajar */}
          {themes.filter((theme) => theme.ribbonType === "premium").length ===
            1 && (
            <>
              <div className="invisible"></div>
              <div className="invisible"></div>
            </>
          )}

          {themes.filter((theme) => theme.ribbonType === "premium").length ===
            2 && <div className="invisible"></div>}
        </div>
      </div>
    </DashboardTemplate>
  );
};

export default SetTheme;
